import { Component } from '@angular/core';

@Component({
	selector: 'ansyn-placeholder',
	template: '',
	styleUrls: []
})

export class PlaceholderComponent {

	constructor() {
	}

}



// WEBPACK FOOTER //
// C:/Users/user/projects/ansyn/src/app/packages/core/components/placeholder/placeholder.component.ts